import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import Layout from "../../layouts";
import {FormControl, InputLabel, MenuItem, Select, Stack, TextField} from "@mui/material";
import {useEffect, useState} from "react";
import {add, format} from "date-fns";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Link from "next/link";
import Loading from "../../components/Loading";
import Box from "@mui/material/Box";
import {getUnits} from "../../lib/services/ApiCalls";

function Index() {

    const [date, setDate] = useState(new Date());
    const [unit, setUnit] = useState(1);
    const [units, setUnits] = useState([]);

    useEffect(() => {
        const retrieveUnits = async () => {
            const units = await getUnits();
            let active_units = units.filter(unit => unit["is_active"] === 1);
            active_units = active_units.sort((current, next) => current.number - next.number);
            setUnit(getFirstUnitOnlyId(units))
            setUnits(active_units);
        }

        if (units.length === 0) {
            retrieveUnits();
        }

    }, []);

    /**
     * Kind of helper operation to set the initial state of select
     * @param units
     * @returns {*}
     */
    const getFirstUnitOnlyId = (units) => {
        for (const unit of units) {
           if (unit.is_active === 1){
               return unit.id;
           }
        }
    }

    return (
        <Layout>
            <Box sx={{mx: 2}}>
                <Loading open={units.length === 0}></Loading>
                <Stack spacing={3} sx={{mb: 2, mt: 6}}>
                    <Typography variant="h5" sx={{textAlign: "center", fontWeight: 500}}>
                        Selecciona la fecha y la unidad a revisar:
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            label="Fecha de tramos"
                            value={date}
                            minDate={new Date("2022-05-01")}
                            maxDate={add(new Date(), {
                                days: 1
                            })}
                            onChange={(newValue) => {
                                setDate(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>
                    {/* Change to retrieve from database */}
                    {units && units.length !== 0 && (
                        <FormControl>
                            <InputLabel id="unit-label">Unidad</InputLabel>
                            <Select
                                labelId="unit-label"
                                id="unit-select"
                                value={unit}
                                label="Age"
                                onChange={(evt) => {
                                    setUnit(evt.target.value)
                                }}
                            >
                                {units.map((e, i) => (
                                    <MenuItem key={i} value={e.id}>ECO {e.number}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                </Stack>
                {units && units.length !== 0 && (
                    <Link href="/tramos/[id]/[date]" as={"/tramos/" + unit + "/" + format(date, 'yyyy-MM-dd') + "/"}
                          passHref>
                        <Button sx={{float: "right"}} variant="contained">Enviar</Button>
                    </Link>
                )}
            </Box>
        </Layout>
    )
}

export default Index